// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TextInput-Clear.module.scss  */
.TextInput-Clear-module-Root_3wV {
  position: relative;
  z-index: 3;
  display: none;
  visibility: hidden;
  width: 24px;
  height: 26px;
  margin: 0 8px;
  cursor: pointer;
  color: #576875; }
  .TextInput-Clear-module-Root_3wV.TextInput-Clear-module-visible_2sY {
    display: block;
    visibility: visible; }
  .TextInput-Clear-module-Root_3wV.TextInput-Clear-module-disabled_35k.TextInput-Clear-module-visible_2sY {
    z-index: 0;
    cursor: default; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/TextInput/Clear/TextInput-Clear.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc,EAAE;EAChB;IACE,cAAc;IACd,mBAAmB,EAAE;EACvB;IACE,UAAU;IACV,eAAe,EAAE","sourcesContent":["/*  imported from TextInput-Clear.module.scss  */\n.TextInput-Clear-module-Root_3wV {\n  position: relative;\n  z-index: 3;\n  display: none;\n  visibility: hidden;\n  width: 24px;\n  height: 26px;\n  margin: 0 8px;\n  cursor: pointer;\n  color: #576875; }\n  .TextInput-Clear-module-Root_3wV.TextInput-Clear-module-visible_2sY {\n    display: block;\n    visibility: visible; }\n  .TextInput-Clear-module-Root_3wV.TextInput-Clear-module-disabled_35k.TextInput-Clear-module-visible_2sY {\n    z-index: 0;\n    cursor: default; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
